import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store'; 
import { exRegisterRouter } from './router-ex-register'; // 健身展商注册地址
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location); 
}



Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', redirect: 'ex-register/register', name: 'exhibition' },
    ...exRegisterRouter, 
  ]
});

// 路由守卫 
router.beforeEach((to, form, next) => {
  next();
});

router.beforeEach((to, form, next) => {
  next()
});
export default router; 
